/**
 * FairLocaleMenu — Language / Currency panel
 * Behavior matches legacy InternationalisationContent:
 * - language → useLocaleStore.setLocale (ru | en)
 * - currency → localStorage `currency` + page reload
 */

export type FairLocaleMenuTab = 'language' | 'currency'

export interface FairLocaleLanguageOption {
  id: string
  /** i18n key for primary label */
  labelKey: string
  /** i18n key for secondary label */
  descriptionKey: string
  flagCode: string
  locale: 'ru' | 'en'
}

export interface FairLocaleCurrencyOption {
  id: string
  label: string
  /** i18n key for description */
  descriptionKey: string
  flagCode: string
  code: string
}

export const FAIR_LOCALE_MENU_TAB_ITEMS = [
  { labelKey: 'internationalization.language', value: 'language' as const },
  { labelKey: 'internationalization.currency', value: 'currency' as const },
]

/** Same set as legacy InternationalisationContent / LanguageSelector */
export const FAIR_LOCALE_LANGUAGE_OPTIONS: FairLocaleLanguageOption[] = [
  {
    id: 'ru',
    labelKey: 'internationalization.russian',
    descriptionKey: 'internationalization.sub.russian',
    flagCode: 'ru',
    locale: 'ru',
  },
  {
    id: 'en',
    labelKey: 'internationalization.english',
    descriptionKey: 'internationalization.sub.english',
    flagCode: 'gb',
    locale: 'en',
  },
]

/** Same set as legacy InternationalisationContent / CurrencySelector */
export const FAIR_LOCALE_CURRENCY_OPTIONS: FairLocaleCurrencyOption[] = [
  {
    id: 'BYN',
    label: 'BYN',
    descriptionKey: 'currency.byn_rub',
    flagCode: 'by',
    code: 'BYN',
  },
  {
    id: 'USD',
    label: 'USD',
    descriptionKey: 'currency.usa_dollar',
    flagCode: 'us',
    code: 'USD',
  },
  {
    id: 'RUB',
    label: 'RUB',
    descriptionKey: 'currency.rus_rub',
    flagCode: 'ru',
    code: 'RUB',
  },
]

export const FAIR_LOCALE_CURRENCY_STORAGE_KEY = 'currency'
export const FAIR_LOCALE_CURRENCY_DEFAULT = 'USD'

export function readStoredCurrency(
  fallback = FAIR_LOCALE_CURRENCY_DEFAULT,
): string {
  if (typeof window === 'undefined') return fallback
  return (
    window.localStorage.getItem(FAIR_LOCALE_CURRENCY_STORAGE_KEY) ?? fallback
  )
}

export function persistCurrency(code: string) {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(FAIR_LOCALE_CURRENCY_STORAGE_KEY, code)
}

export function applyCurrencyAndReload(code: string) {
  persistCurrency(code)
  if (typeof window !== 'undefined') {
    window.location.reload()
  }
}
